module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/134-liechtenstein-28fa84969a96e0b83c8692bd0377a08e.svg";